<template>
  <div class="centerPage">
    <div class="pageTit">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/doctor/articles' }">文章管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ status == 0 ? '新增' : '编辑' }}文章-<span style="font-size: 14px;">{{ group[activeName] }}</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="form" :model="articleData" class="article_edit" :rules="rules">
      <el-form-item label="类型：" v-show="status==0" prop="">
        <el-radio-group v-model="activeName" class="type">
          <el-radio :label="index" v-for="(obj ,index ) in group" :key="index">{{ obj }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="缩略图：">
        <el-upload :action="uploadUrl"
                   list-type="picture-card"
                   :show-file-list="false"
                   name="uploadFile"
                   class="uploadImg"
                   :on-success="handleImageSuccess">
          <img v-if="imageUrl" :src="articleData.thumbnailPath" class="img"/>
          <div v-else class="maxHeight">点击上传</div>
        </el-upload>
        <i v-if="articleData.thumbnailPath" class="el-icon-delete" @click="imageUrl=articleData.thumbnailPath=''"></i>
      </el-form-item>
      <el-form-item label="文章类型：" v-if="activeName==0" prop="pageType">
        <el-radio-group v-model="articleData.pageType" class="type artTy page-type">
          <el-radio :label="obj.id" v-for="(obj ,index ) in articleTypes" :key="index">{{ obj.itemName }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="登录可见：" v-if="activeName!=2">
        <el-radio-group v-model="articleData.readAuthority" class="type artTy">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="文章类型：" v-if="activeName==2" prop="scienceType">
        <el-radio-group v-model="articleData.scienceType" class="type artTy page-type">
          <el-radio :label="obj.id" v-for="(obj ,index ) in articleType" :key="index">{{ obj.itemName }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="标题：" prop="title">
        <el-input v-model="articleData.title" maxlength="80" show-word-limit style="width: 1000px" placeholder="请输入标题">{{ articleData.title }}?
        </el-input>
      </el-form-item>
      <el-form-item label="摘要：" prop="summary">
        <el-input v-model="articleData.summary" type="textarea"  maxlength="200" show-word-limit
                  :autosize="{ minRows: 3, maxRows: 3}" style="width: 1000px" placeholder="请输入简述"></el-input>
      </el-form-item>
      <!---->
      <el-form-item label="正文：" class="quill_parent" prop="pageContent">
        <tinymce v-model="articleData.pageContent" :height="300" style="width: 1000px"/>
      </el-form-item>
      <div class="btn">
        <el-button @click="save(0)">
          保存
        </el-button>
        <el-button @click="save(1)">
          提交
        </el-button>
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="form.imageUrl" alt="">
    </el-dialog>

  </div>
</template>

<script>
import base from '@/api/common';
import Tinymce from '@/components/Tinymce'


export default {
  name: "article_edit",
  data() {
    return {
      editor: null,   // 富文本编辑器对象
      content: `<p></p><p><br></p><ol></ol>`, // 富文本编辑器默认内容
      editorOption: { //  富文本编辑器配置
        modules: {
          toolbar: '#toolbar'
          // toolbar: true
        },
        theme: 'snow',
        placeholder: '请输入正文'
      },

      state: Number(this.$route.query.state),
      form: {
        status: 0,
        imageUrl: [],
        radio: 0,
        title: '',
        desc: ''
      },
      group: ['每日研究', '新闻资讯', '公益科普'],
      dialogVisible: false,
      disabled: false,
      articleTypes: [],
      articleType: [],
      articleTypeMap: new Map(),
      articleData: {
        readAuthority: 1,
        status: 0,
      },//文章数据

      activeName: 0,//文章的类型/新增文章
      articleID: this.$route.query.id || "",//文章的id
      //保存或更新的地址
      saveUrl: "",//上传地址
      uploadUrl: base.bannerUploadUrl || ' ',
      imageUrl: '',// 新增上传组件显示上传的图片
      status: this.$route.query.status,

      rules: {
        pageType: [
          {required: true, message: '请选择类型', trigger: 'change'}
        ],
        // readAuthority: [
        // 	{required: true, message: '请选择'}
        // ],
        scienceType: [
          {required: true, message: '请选择类型', trigger: 'change'}
        ],
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {min: 1, max: 200, message: '标题过长', trigger: 'blur'}
        ],
        summary: [
          {required: true, message: '请输入摘要', trigger: 'blur'},
          {min: 1, max: 1000, message: '简述过长', trigger: 'blur'}
        ],
        pageContent: [
          {required: true, message: '请输入正文', trigger: 'blur'},
        ],
      },//校验规则

    }
  },
  methods: {
    //显示已保存内容
    getArticleEdit() {
      let that = this;
      let url;
      this.activeName = Number(this.state);
      //判断是每日研究/新闻资讯/公益科普/新增文章
      if (this.status == 0) {
        //新增文章
      } else {
        if (this.state == null || this.articleID == null) {
          that.$router.back();
        }
        if (this.state === 0) {
          //每日研究
          url = base.api.article.research.edit;
        } else if (this.state == 1) {
          //新闻资讯
          url = base.api.article.information.edit;
        } else if (this.state == 2) {
          //公益科普
          url = base.api.article.science.edit;
        } else {
          that.$router.back();
        }
        this.$ajax
            .get(url.replace("{id}", this.articleID))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.articleData = res.data.data;
                if(res.data.data.thumbnailPath){
                  that.imageUrl = res.data.data.thumbnailPath;
                }

                console.log('img url: ' + that.imageUrl);
                console.log('thumbnailPath url: ' + res.data.data.thumbnailPath);
              } else {
                that.$message.error('数据加载失败');
              }
            }).catch((err) => {
              console.error(err)
        })
      }
    },
    //保存/提交
    save(type) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          //判断是保存为草稿还是提交,默认为草稿(0)
          if (type === 1) {
            this.articleData.approveStatus = 1;
          } else {
            this.articleData.approveStatus = 0;
          }
          //判断是新增还是更新
          if (this.status != 1) {
            //新增为草稿,判断是新增哪类文章
            if (this.activeName == 0) {
              this.saveUrl = base.api.article.research.add;
            } else if (this.activeName == 1) {
              this.saveUrl = base.api.article.information.add;
            } else if (this.activeName == 2) {
              this.saveUrl = base.api.article.science.add;
            }
          } else if (this.state == 0) {
            this.saveUrl = base.api.article.research.update;
          } else if (this.state == 1) {
            this.saveUrl = base.api.article.information.update;
          } else if (this.state == 2) {
            this.saveUrl = base.api.article.science.update;
          }
          let that = this;
          this.$ajax.post(this.saveUrl, this.articleData).then(function (res) {
            if (res.data.status === 'success') {
              that.$message.success('操作成功');
              window.history.go(-1);
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error('操作失败');
          })
        } else {
          this.$message.error('请检查字段');
          return false;
        }
      });
    },
    //上传图片
    handleImageSuccess(res, file) {// 新增上传组件
      this.imageUrl = URL.createObjectURL(file.raw);
      this.articleData.thumbnailPath = res.message;

      console.log(this.articleData.thumbnailPath);

    },
    handleImageRemove(file,fileList){
      console.log('file', file);
      console.log('fileList', fileList);
      this.articleData.thumbnailPath = '';
    }
  },
  mounted() {
    let vm = this;
    this.$ajax.get(base.api.dict.article.research).then((res) => {
      if (res.data.status === 'success') {
        vm.articleTypes = res.data.list;
        $(res.data.list).each((i, o) => {
          vm.articleTypeMap.set(o.id, o);
        });
      }
    });
    this.$ajax.get(base.api.dict.article.science).then((res) => {
      if (res.data.status === 'success') {
        this.articleType = res.data.list;
        $(res.data.list).each((i, o) => {
          this.articleTypeMap.set(o.id, o);
        })
      }
    });
    this.getArticleEdit()
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  components: {
    Tinymce
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/banner.scss';

.centerPage {
  display: block;
}

.ql-snow .ql-color-picker, .ql-snow .ql-picker.ql-header {
  line-height: 24px;
}

.uploadImg{
  img{
    height: 100%;
    width: 100%;
  }
}
i.el-icon-delete{
  position: absolute;
  top: 36px;
  right: -30px;
  font-size: 20px;
  color: #567BFF;
  cursor: pointer;
}
.page-type{
  max-width: 1080px;
}
</style>
